<app-user-message *ngIf="showForm && presentation === 'inline'" type="confirmation" [title]="heading" [message]="body" [dismissible]="false">
  <p *ngIf="detail">{{ detail }}</p>
  <div messageActions class="user-message-actions">
    <button type="button" class="btn btn-outline-secondary" [disabled]="busy" (click)="Cancel()">{{ rejectLabel }}</button>
    <button type="button" class="btn" [ngClass]="color === 'danger' ? 'user-message-danger' : 'btn-primary'" [disabled]="busy" (click)="Confirm()">{{ acceptLabel }}</button>
  </div>
</app-user-message>
